import React from "react";
import { FaMoneyBill, FaShoppingBag, FaWallet } from "react-icons/fa";
import Button from "../components/Button";
import Elephent from "../assets/elephant.png";
import ElephantAndDog from "../assets/elephentanddog.png";

const HowToBuy = () => {
  return (
    <>
      <div className="bg-warm-yellow relative px-4 md:px-16 py-12 flex flex-col items-center md:flex-row text-center md:text-left">
        <div className="basis-1/2 space-y-4">
          <h1 className="text-3xl md:text-6xl font-bold">
            Presale Is Live <br />
            Join ELEPHONK Now
          </h1>
          <p className="text-sm md:text-2xl">
            Lorem, ipsum dolor sit amet consectetur adipisicing elit. Explicabo
            non delectus doloribus, consequuntur voluptate aliquam. Placeat
            eveniet distinctio ab non!
          </p>
          <div>
            <a href="#home">
              <Button className={"text-sm md:text-xl mx-auto md:mx-0"}>
                Buy Now
              </Button>
            </a>
          </div>
        </div>
        <div className="basis-1/2 text-center ">
          <img src={Elephent} alt="" className="mx-auto" />
        </div>
      </div>
      <div
        id="howtobuy"
        className="bg-warm-yellow   text-black py-20 px-8 md:px-16 relative h-full"
      >
        <img
          src={ElephantAndDog}
          className="h-[70%] hidden md:block absolute bottom-0 right-0 translate-y-24"
          alt=""
        />
        <div className="md:w-[70%]">
          <div className="pb-8 text-center md:text-left">
            <h1 className="text-3xl md:text-6xl pb-2 font-bold text-black">
              How to buy <span className="elephonkHeading">Elephonk</span>{" "}
              presale
            </h1>
            <p className="text-black text-sm md:text-xl">
              Ready to dive into the ELEPHONK revolution? Purchasing ELEPHONK
              Presale is a breeze! <br /> Follow our simple steps to join the
              ELEPHONK community:
            </p>
          </div>
          <div className="space-y-8">
            <div className="w-full rounded-lg border-2 border-black flex flex-col md:flex-row items-center md:items-start text-center md:text-left p-8 gap-4 md:gap-8 bg-primary">
              <div>
                <FaWallet className="text-3xl md:text-4xl" />
              </div>
              <div>
                <div className="text-xl md:text-2xl font-semibold pb-2">
                  Select Wallet
                </div>
                <p className="text-sm md:text-xl ">
                  Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                  Ducimus, eaque..
                </p>
              </div>
            </div>
            <div className="w-full rounded-lg border-2 border-black flex flex-col md:flex-row items-center md:items-start text-center md:text-left p-8 gap-4 md:gap-8 bg-primary">
              <div>
                <FaMoneyBill className="text-3xl md:text-4xl" />
              </div>
              <div>
                <div className="text-xl md:text-2xl font-semibold pb-2">
                  Choose Amount
                </div>
                <p className="text-sm md:text-xl ">
                  Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                  Ducimus, eaque..
                </p>
              </div>
            </div>
            <div className="w-full rounded-lg border-2 border-black flex flex-col md:flex-row items-center md:items-start text-center md:text-left p-8 gap-4 md:gap-8 bg-primary">
              <div>
                <FaShoppingBag className="text-3xl md:text-4xl" />
              </div>
              <div>
                <div className="text-xl md:text-2xl font-semibold pb-2">
                  Click Buy Now
                </div>
                <p className="text-sm md:text-xl ">
                  Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                  Deserunt, sapiente molestiae aut deleniti possimus labore.
                </p>
                <p className="text-sm md:text-xl ">
                  Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                  Ducimus, eaque.. Lorem ipsum dolor, sit amet consectetur
                  adipisicing elit. Veniam, saepe? Quibusdam sit itaque sapiente
                  deserunt.{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HowToBuy;
